<template>
  <div
    :class="$style.root"
    :data-has-pagination="childData?.meta?.pagination?.page < childData?.meta?.pagination?.pageCount ? '' : null"
  >
    <div :class="$style.content">
      <LayoutPageHeaderComponent
        :data="localizedData"
        :image="image?.attributes"
      />

      <ul :class="$style.list">
        <template
          v-for="(entry, index) in childData?.data"
        >
          <li
            v-if="firstOfYear(entry, childData?.data[index - 1])"
            :class="$style['group-key']"
          >
            {{ getYear(entry?.attributes?.date) }}
          </li>

          <li
            :class="$style.item"
            :data-before-group-key="firstOfYear(childData?.data[index + 1], entry) ? '' : null"
          >
            <I18nLinkWithFallback
              name="talks-slug"
              :localizedData="getLocalizedData(entry)?.attributes"
              :class="$style.link"
            >
              {{ getTitle(getLocalizedData(entry)?.attributes) }}
            </I18nLinkWithFallback>
          </li>
        </template>
      </ul>

    </div>

    <LayoutPaginationComponent
      :pagination="childData?.meta?.pagination"
      :paginateChildData="paginateChildData"
    />
  </div>
</template>

<script setup>
import { sample } from 'lodash-es'

const props = defineProps({
  pageData: Object,
  childData: {
    type: Object,
    required: false,
  },
  paginateChildData: {
    type: Function,
    required: false,
  }
})

const getLocalizedData = i18nGetLocalizedData

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

const image = computed(() => {
  const entriesWithImages = props?.childData?.data?.filter((entry) => entry.attributes?.images?.data?.length)
  if (entriesWithImages?.length) {
    const entry = sample(entriesWithImages)
    return sample(entry?.attributes?.images?.data)
  }
})

const getYear = (date) => {
  if (!date) return
  return new Date(date).getFullYear()
}

const firstOfYear = (a, b) => {
  return getYear(a?.attributes?.date) !== getYear(b?.attributes?.date)
}

const getTitle = (data) => i18nGetLocalizedTitle(data)
</script>

<style module>
.content {
  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 3);
}

.list {
  composes: reset-list container--default from global;
}

.group-key {
  composes: font-size-small from global;
  border-bottom: var(--stroke--medium) solid currentColor;
  padding-bottom: var(--unit--spacer);
  margin-bottom: calc(var(--unit--spacer) - (var(--lh) - var(--fs)) + var(--stroke--medium));
}

.item {
  margin-bottom: calc(var(--unit--spacer) - (var(--lh) - var(--fs)) + var(--stroke--default));
  padding-bottom: var(--unit--spacer);
}

.item {
  border-bottom: var(--stroke--default) solid var(--color--primary);
}

.item[data-before-group-key] {
}

.link {
  composes: reset-link from global;
  display: block;
}

.link:hover,
.link:global(.router-link-exact-active) {
  color: var(--color--yellow);
}
</style>
